export const statusMap = {
  undefined: "Неопознанный",
  new: "Новый",
  layouting_awaiting: "Ожидает компоновки",
  layouting: "Компонуется",
  layouting_completed: "Компоновка завершена",
  printing_awaiting: "Ожидает печати",
  printing: "Печатается",
  printing_completed: "Печать завершена",
  cutting_awaiting: "Ожидает резки",
  cutting: "Режется",
  cutting_completed: "Резка завершена",
  packaging_awaiting: "Ожидает упаковки",
  packaging: "Упаковывается",
  packaging_completed: "Упаковка завершена",
};